import { render } from "./RegionalsView.vue?vue&type=template&id=5cfaa4aa&scoped=true"
import script from "./RegionalsView.vue?vue&type=script&lang=js"
export * from "./RegionalsView.vue?vue&type=script&lang=js"

import "./RegionalsView.vue?vue&type=style&index=0&id=5cfaa4aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfaa4aa"]])

export default __exports__